import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const ranges = ["1h", "6h", "24h", "7d", "30d"] as const;

export type TimeRange = (typeof ranges)[number];

interface TimeRangeSelectorProps {
  value: TimeRange;
  onChange: (range: TimeRange) => void;
}

export function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps) {
  return (
    <div className="flex items-center gap-1">
      {ranges.map((range) => (
        <Button
          key={range}
          variant={value === range ? "default" : "outline"}
          size="xs"
          onClick={() => onChange(range)}
          className={cn(
            "min-w-[3rem] font-mono text-[12px]",
            value !== range && "text-muted-foreground",
          )}
        >
          {range}
        </Button>
      ))}
    </div>
  );
}
